import { addStream } from '../../epicStore'
import {  Observable } from 'rxjs'
import { pluck, map, tap, mapTo, takeUntil } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as actionTypes from '../../../constants/actionTypes'
import events$ from './eventsObservable'
import { setupTypes } from '../../../actions/setup/setupTypes'
import { roomTypes } from '../../../actions/room/roomTypes'
import { ReduxAction } from '../../../reducers/reducerType'

const addEvents$ = (actions$, state) => actions$.pipe(
  ofType(setupTypes.SET_ROOM),
  pluck('payload'),
  map(room => events$(room, state)
      .pipe(
        takeUntil(
          actions$.pipe(
            ofType(roomTypes.TEAR_DOWN_ROOM_SUCCESS)
          )
        )
      )
  ),
  tap((stream$: Observable<ReduxAction>) => addStream(stream$)),
  mapTo({ type: actionTypes.SET_ROOM_LISTENERS })
)

export default addEvents$
